import { render } from "./FAQ.vue?vue&type=template&id=2e92d618&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=2e92d618&lang=scss&scoped=true"
import "./FAQ.vue?vue&type=style&index=1&id=2e92d618&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e92d618"]])

export default __exports__